import './HowItWorks.css';
import step1 from '../../assets/step1.png';
import step2 from '../../assets/step2.png';
import step3 from '../../assets/step3.png';

const STEPS = [
  {
    image: step1,
    alt: 'Krok 1: Anonimowo opisz swój problem — swoimi słowami',
    rotation: -3,
  },
  {
    image: step2,
    alt: 'Krok 2: Następnie zostaniesz połączony z 3 osobami, które zmagają się z tym samym problemem',
    rotation: 2.5,
  },
  {
    image: step3,
    alt: 'Krok 3: Porozmawiaj, wymień się doświadczeniem oraz wsparciem',
    rotation: -2,
  },
];

function HowItWorks() {
  return (
    <section id="about" className="how-it-works" aria-labelledby="how-it-works-title">
      <h2 id="how-it-works-title" className="how-it-works__title">
        Jak to działa?
      </h2>

      <ol className="how-it-works__steps">
        {STEPS.map((step, index) => (
          <li
            key={index}
            className="how-it-works__step"
            style={{ '--step-rotation': `${step.rotation}deg` }}
          >
            <img src={step.image} alt={step.alt} loading="lazy" />
          </li>
        ))}
      </ol>
    </section>
  );
}

export default HowItWorks;
